import React from 'react';
import { Box, Typography, Button } from '@mui/material'; // Ensure you have Material-UI installed

const Reauth = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f8f9fa',
        padding: 4,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 'bold',
          color: '#dc3545', // Bootstrap danger color
          marginBottom: 2,
        }}
      >
        Connection Failed
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: '#6c757d', // Bootstrap secondary color
          textAlign: 'center',
          marginBottom: 3,
        }}
      >
        It seems the connection to Stripe wasn't completed. Please try again.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href="/connect-stripe"
        sx={{
          padding: '10px 20px',
          borderRadius: 5,
          boxShadow: 2,
          '&:hover': {
            backgroundColor: '#0056b3', // Darker blue for hover
          },
        }}
      >
        Connect Payment Account
      </Button>
    </Box>
  );
};

export default Reauth;
